import React from 'react';
import bgimg from "../../images/digital_advisory.png";
import Card from './Card';

const BackgroundImageComponent = () => {
  return (
    <div className="bg-[#f8fafc] min-h-screen">
      {/* Hero Banner Section */}
      <div className="relative w-full overflow-hidden">
        {/* Sleek Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#0b0f19] via-[rgba(11,15,25,0.85)] to-transparent z-10"></div>
        <div className="absolute inset-0 bg-black/40 z-0"></div>
        
        <div 
          className="relative bg-center bg-no-repeat bg-cover h-[340px] flex items-center z-0" 
          style={{ backgroundImage: `url(${bgimg})` }}
        >
          <div className="relative z-20 max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 w-full">
            <div className="max-w-2xl text-left text-white">
              {/* Modern Title Badge */}
              <span className="inline-block px-3 py-1 mb-4 text-xs font-semibold uppercase tracking-wider text-[#9f8aff] bg-[#9f8aff]/10 border border-[#9f8aff]/20 rounded-full">
                Our Portfolio
              </span>
              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight mb-4 text-white leading-tight">
                We Take Pride in Our Work
              </h1>
              <p className="text-sm sm:text-base lg:text-lg text-slate-300 leading-relaxed font-light">
                We have partnered with some of the world’s most prominent brands. Here are just a few examples of the solutions we've built with our amazing clients.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Case Studies Grid Component */}
      <div className="py-12 sm:py-16">
        <Card />
      </div>
    </div>
  );
};

export default BackgroundImageComponent;
